<mat-checkbox
  class="mat-option"
  [indeterminate]="isIndeterminate()"
  [checked]="isChecked()"
  [disabled]="disabled"
  (click)="$event.stopPropagation()"
  (change)="toggleSelection($event)">
  {{ text }}
</mat-checkbox>
